module.exports = __webpack_public_path__ + "static/media/background-carousel.2c033d11.png";